/**
 * Account Deletion Form Controller
 *
 * Handles the dedicated account deletion page:
 * - Validates checkbox + confirmation text to enable/disable the delete button
 * - On form submit: opts out from push notifications, then submits the form
 */
import { Controller } from "@hotwired/stimulus"
import { optOutAndClearDeviceForDeletion } from "./onesignal_device_controller"

export default class extends Controller {
  static targets = ["checkbox", "confirmationInput", "submitButton"]
  static values = { confirmationWord: { type: String, default: "" } }

  connect() {
    this.updateSubmitButton()
  }

  validate() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return

    const checkboxChecked = this.hasCheckboxTarget ? this.checkboxTarget.checked : false
    const confirmationValue = this.hasConfirmationInputTarget
      ? this.confirmationInputTarget.value.trim().toUpperCase()
      : ""
    const word = (this.confirmationWordValue || "").toString().trim().toUpperCase()
    const isValid = checkboxChecked && word.length > 0 && confirmationValue === word

    this.submitButtonTarget.disabled = !isValid
  }

  async handleSubmit(event) {
    event.preventDefault()

    const form = event.target
    const button = this.hasSubmitButtonTarget ? this.submitButtonTarget : null

    if (button) {
      button.disabled = true
      button.textContent = button.dataset.loadingText || "..."
    }

    try {
      await optOutAndClearDeviceForDeletion()
    } catch (error) {
      console.error("[AccountDeletionForm] Push opt-out failed:", error)
    }

    form.submit()
  }
}
